import { Controller } from "@hotwired/stimulus"

export default class CssController extends Controller {
  static targets = ["elementToChange"]
  static values = { status: Boolean }
  static classes = ["css"]

  toggle() {
    this.flipState()
  }

  flipState() {
    this.statusValue = !this.statusValue
  }

  statusValueChanged() {
    this.updateHiddenClass()
  }

  updateHiddenClass() {
    for (const oneCssClass of this.cssClasses) {
      this.elementToChangeTarget.classList.toggle(
        oneCssClass,
        this.statusValue
      )
    }
  }
}